import { Injectable } from "@angular/core";
import { AppConstants } from "src/app-constants";
import { AdditionalRequestDetails, Authentication } from "../internal-models/additional-request-details";
import { ApiRequest } from "../service-models/api-contracts/base/api-request";
import { ApiResponse } from "../service-models/api-contracts/base/api-response";
import { SignUpSM } from "../service-models/sign-up.s-m";
import { TokenRequestSM } from "../service-models/token/token-request-s-m";
import { TokenResponseSM } from "../service-models/token/token-response-s-m";
import { StorageService } from "../services/storage.service";
import { BaseApiClient } from "./base-client/base-api.client";
import { CommonResponseCodeHandler } from "./helpers/common-response-code-handler.helper";
import { StorageCache } from "./helpers/storage-cache.helper";

@Injectable({
    providedIn: 'root'
})
export class AccountClient extends BaseApiClient {
    constructor(storageService: StorageService, storageCache: StorageCache,
        commonResponseCodeHandler: CommonResponseCodeHandler) {
        super(storageService, storageCache, commonResponseCodeHandler)
    }
    GenerateToken = async (tokenRequestSM: ApiRequest<TokenRequestSM>): Promise<ApiResponse<TokenResponseSM>> => {
        let resp = await this.GetResponseAsync<TokenRequestSM, TokenResponseSM>
            (`${AppConstants.ApiUrls.ACCOUNT_URL}/ValidateLoginAndGenerateToken`, 'POST', tokenRequestSM,
                new AdditionalRequestDetails<TokenResponseSM>(false, Authentication.false));
        return resp;
    }
 /**Add a New  User*/
    RegisterUser = async (registerUser: ApiRequest<SignUpSM>) : Promise<ApiResponse<SignUpSM>> => {
        let resp = await this.GetResponseAsync<SignUpSM, SignUpSM>
        (`${AppConstants.ApiUrls.REGISTER_USER_URL}/registerUser`, 'POST', registerUser,
            new AdditionalRequestDetails<SignUpSM>(false, Authentication.false)
        );
        return resp;
    }
}
